/** Query keys used for deals list / filter sheet (not persisted when applying filters). */
export const DEALS_FILTER_QUERY_KEYS = [
  "time_of_day",
  "date",
  "area",
  "lat",
  "lng",
  "category",
  "cuisine",
  "occasion",
  "price_band",
  "discount_type",
];

export const stripDealsFilterQueryParams = (searchString) => {
  const p = new URLSearchParams(searchString || "");
  DEALS_FILTER_QUERY_KEYS.forEach((k) => p.delete(k));
  return p;
};

export const pathnameWithSearchPreservingNonFilters = (
  pathname,
  searchString,
) => {
  const p = stripDealsFilterQueryParams(searchString);
  const qs = p.toString();
  return qs ? `${pathname}?${qs}` : pathname;
};
